import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// import { Link } from '@reach/router'
import { Link } from 'react-router-dom'

import { isRoutedUrl, isPdfUrl, isLocal, isCms } from '../../utility'

import { halApi } from '../utilities/utilities.js'

import DOMPurify from 'dompurify'

export const Link2 = ({
  children,
  onClick,
  url,
  text,
  icon,
  className,
  parentClasses,
  textClasses,
  iconColor,
  arrow,
  ...rest
}) => {
  const [iconMap, setIconMap] = useState({})

  useEffect(() => {
    const iconMapScope = 'administration/value-lists/cti-icon-map'

    const getAdminDoc = async () => {
      if (!icon) {
        return
      }
      const adminDoc = await halApi('documents', iconMapScope, true)

      if (adminDoc) {
        parseValueList(adminDoc)
      }
    }

    getAdminDoc()
  }, [])

  const parseValueList = (response) => {
    if (response?._embedded?.documents?.[0]?.listitem) {
      const _response = response._embedded.documents[0].listitem.reduce(
        (prev, curr) => {
          return { ...prev, [curr.key]: curr.label }
        },
        {}
      )

      setIconMap(_response)
    }
  }

  const arrowMap = {
    white: 'icon_chevron_white',
    brand: 'icon_chevron_brand_light',
  }

  const renderIcon = () => {
    return (
      iconMap[icon] &&
      (!className || className.indexOf('Button') < 0) && (
        <span
          className={`Icon--material u-textSizeMsrp1 ${
            iconColor || 'u-textColorBrandLight'
          }`}
          style={{ marginRight: 2, transform: 'translate(-2px, -1px)' }}
        >
          {iconMap[icon]}
        </span>
      )
    )
  }

  const renderChildren = () => {
    return (
      children || (
        <div className="u-flex u-flexAlignItemsCenter">
          {iconMap[icon] && className && className.indexOf('Button') > -1 && (
            <span
              className={`Icon--material u-marginRight2gu u-textSizeMsrp1 ${
                iconColor || 'u-textColorBrandLight'
              }`}
            >
              {iconMap[icon]}
            </span>
          )}
          <div className={`${textClasses || ''}`}>{text}</div>
          {arrow && (
            <img
              alt=""
              src={`${
                isLocal() || isCms() ? '/cti-site' : ''
              }/webfiles/latest/assets/cti/images/${arrowMap[arrow]}.svg`}
              style={{ transform: 'translateY(1px)' }}
            />
          )}
        </div>
      )
    )
  }

  return (
    <>
      {onClick ? (
        <div className="u-flex u-flexAlignItemsCenter">
          {renderIcon()}
          <button onClick={onClick} className={`${className || ''}`} {...rest}>
            {renderChildren()}
          </button>
        </div>
      ) : !isRoutedUrl(url) ? (
        <div className={`u-flex u-flexAlignItemsCenter ${parentClasses}`}>
          {renderIcon()}
          <a
            href={DOMPurify.sanitize(url)}
            className={`u-flex u-flexAlignItemsCenter ${className || ''}`}
            target={isPdfUrl(url) ? '_blank' : '_self'}
            rel="noreferrer"
            {...rest}
          >
            {renderChildren()}
          </a>
        </div>
      ) : (
        <div className="u-flex u-flexAlignItemsCenter">
          {renderIcon()}
          <Link
            to={url}
            state={{ doScroll: true }}
            className={`u-flex u-flexAlignItemsCenter ${className || ''}`}
            target={isPdfUrl(url) ? '_blank' : '_self'}
            rel="noreferrer"
            {...rest}
          >
            {renderChildren()}
          </Link>
        </div>
      )}
    </>
  )
}

Link2.propTypes = {
  children: PropTypes.object,
  onClick: PropTypes.func,
  url: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.string,
  className: PropTypes.string,
  parentClasses: PropTypes.string,
  textClasses: PropTypes.string,
  iconColor: PropTypes.string,
  arrow: PropTypes.string,
}
